import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const founderTimeline = [
    'Una necesidad real',
    'El primer proyecto',
    'Integración con Contífico',
    'HomeSanty',
];

const visionPoints = [
    'Catálogo conectado a la operación del negocio.',
    'Inventario y precios sincronizados.',
    'Pagos online.',
    'Facturación.',
    'Un nuevo canal de ventas.',
];

const AboutUsSection = () => {
    return (
        <section className="about-us-section" aria-labelledby="about-us-title">
            <div className="about-us-shell">
                <Row className="g-4 g-xl-5 align-items-center">
                    <Col lg={5} xl={4}>
                        <div className="about-us-figure">
                            <div className="about-us-image-wrap">
                                <img
                                    src="/images/about-founder-placeholder.jpg"
                                    alt="Pedro, fundador de HomeSanty"
                                    className="about-us-image"
                                />
                            </div>
                            <div className="about-us-founder-meta">
                                <p className="about-us-founder-name">Pedro José Ortiz Solis</p>
                                <p className="about-us-founder-role">
                                    Fundador y desarrollador de HomeSanty
                                </p>
                                <a
                                    href="https://www.linkedin.com/in/pedroj-ortiz/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="about-us-linkedin"
                                    aria-label="Ver el perfil de Pedro José Ortiz Solis en LinkedIn"
                                >
                                    LinkedIn <span aria-hidden="true">↗</span>
                                </a>
                            </div>
                        </div>
                    </Col>

                    <Col lg={7} xl={8}>
                        <div className="about-us-copy">
                            <span className="about-us-eyebrow">Quiénes somos</span>
                            <h2 id="about-us-title" className="section-title about-us-title">
                                Detrás de HomeSanty hay una historia.
                            </h2>
                            <p className="about-us-lead">
                                HomeSanty nació resolviendo una necesidad real dentro de un negocio
                                familiar. Antes de pensar en una plataforma, pensamos en cómo vender
                                mejor, organizar la operación y conectar el comercio de siempre con
                                un canal digital que sí sirviera.
                            </p>

                            <div className="about-us-story">
                                <p>
                                    Soy Pedro José Ortiz Solis, desarrollador de software y la
                                    persona detrás de HomeSanty. Desde Cuenca, Ecuador, viví de cerca
                                    la realidad de Comercial Santy y entendí lo complejo que puede
                                    ser manejar productos, inventario, precios, clientes, pedidos,
                                    facturación y ventas online sin desordenar la operación del día a
                                    día.
                                </p>
                                <p>
                                    En lugar de mirar ese problema solo desde el comercio, empecé a
                                    construir las herramientas que necesitábamos para resolverlo.
                                    Así nació el primer proyecto: una forma de conectar la operación
                                    existente con una experiencia de venta más ordenada, más útil y
                                    más cercana a lo que el negocio realmente necesitaba.
                                </p>
                                <p>
                                    HomeSanty surgió de ese proceso. Primero fue una necesidad
                                    interna, luego una integración más completa con Contífico y hoy
                                    sigue evolucionando como una plataforma pensada para ayudar a
                                    otros comercios a vender por internet sin tener que empezar otra
                                    vez desde cero.
                                </p>
                            </div>

                            <div className="about-us-timeline" aria-label="Evolución de HomeSanty">
                                {founderTimeline.map((item, index) => (
                                    <React.Fragment key={item}>
                                        <div className="about-us-timeline-item">
                                            <span className="about-us-timeline-index">
                                                {index + 1}
                                            </span>
                                            <span>{item}</span>
                                        </div>
                                        {index < founderTimeline.length - 1 && (
                                            <span
                                                className="about-us-timeline-separator"
                                                aria-hidden="true"
                                            >
                                                →
                                            </span>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>

                            <div className="about-us-problem">
                                <h3>La necesidad que vimos de cerca</h3>
                                <p>
                                    Muchos negocios ya tienen productos, inventario, precios,
                                    clientes y procesos de facturación gestionados en sistemas como
                                    Contífico, pero conectar esa operación existente con un canal
                                    moderno de ventas online no siempre es simple. El reto no es
                                    reemplazar lo que ya funciona, sino integrarlo bien para que el
                                    negocio pueda vender por internet con más orden, continuidad y
                                    claridad.
                                </p>
                            </div>

                            <div className="about-us-vision">
                                <blockquote>
                                    Queremos que un comercio pueda vender en internet sin tener que
                                    reconstruir su negocio desde cero.
                                </blockquote>
                                <ul>
                                    {visionPoints.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="about-us-closing">
                                <p className="about-us-closing-statement">
                                    Primero fuimos comercio. Después construimos la tecnología que
                                    necesitábamos.
                                </p>
                                <p className="mb-0">
                                    Hoy HomeSanty está evolucionando para que otros negocios también
                                    puedan beneficiarse de la misma lógica: aprovechar lo que ya han
                                    construido y convertirlo en un canal digital útil, conectado y
                                    sostenible.
                                </p>
                            </div>

                            <Link
                                to="/partners"
                                className="btn btn-primary about-us-cta rounded-pill px-4 py-2 fw-semibold"
                            >
                                Conoce cómo funciona HomeSanty
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    );
};

export default AboutUsSection;
